import { render } from "./form_index1.vue?vue&type=template&id=00efba08&scoped=true"
import script from "./form_index1.vue?vue&type=script&lang=js"
export * from "./form_index1.vue?vue&type=script&lang=js"

import "./form_index1.vue?vue&type=style&index=0&id=00efba08&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00efba08"]])

export default __exports__